import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  SharedProfileAdapter,
  SharedProfileLoadResult,
  SharedPasswordUpdatePayload,
  SharedProfileValues,
} from 'sham-components/shared/profile';
import { API_BASE_URL } from '@/environments/environment';

const IAM_BASE_URL = `${API_BASE_URL}/api/admin/iam/sellers`;

@Injectable({
  providedIn: 'root',
})
export class SellerProfileAdapter implements SharedProfileAdapter {
  private readonly http = inject(HttpClient);

  loadProfile(): Observable<SharedProfileLoadResult> {
    const sellerUserId = window.localStorage.getItem('seller_id') ?? '';
    if (!sellerUserId) {
      return of({
        values: {
          fullName: '',
          email: '',
          address: '',
          phoneNumber: '',
          dateOfBirth: '',
          storeName: '',
        },
        profileEditable: false,
        rejectionReason: '',
      });
    }

    return this.http
      .get<SellerDetailsResponse>(`${IAM_BASE_URL}/${sellerUserId}`)
      .pipe(
        map((seller) => {
          const isRejected = seller.status === 0 || seller.ActivationStatus === 0;
        const values: SharedProfileValues = {
          fullName: seller.fullName ?? '',
          email: seller.email ?? '',
          address: seller.address ?? '',
          phoneNumber: seller.phoneNumber ?? '',
          dateOfBirth: seller.dateOfBirth?.split('T')[0] ?? '',
          storeName: seller.businessName ?? '',
        };

          return {
            values,
            profileEditable: !isRejected,
            rejectionReason: isRejected
              ? (seller.reviewNotes ?? 'Profile was rejected.')
              : '',
          };
        }),
      );
  }

  saveProfile(payload: SharedProfileValues): Observable<void> {
    console.log('Seller profile save payload', payload);
    return of(void 0);
  }

  updatePassword(payload: SharedPasswordUpdatePayload): Observable<void> {
    console.log('Seller password update payload', payload);
    return of(void 0);
  }
}

interface SellerDetailsResponse {
  userId: string;
  fullName: string;
  email: string;
  phoneNumber: string | null;
  address: string | null;
  dateOfBirth: string | null;
  businessName: string;
  status?: number;
  ActivationStatus?: number;
  reviewNotes: string | null;
}
